import apiRequest from '@/services/apiRequest';
import { getSearchApi } from '@/utility/getCoreApi';

const rentalsRequest = async ({ params = {}, lat, lon, count = 8, offset = 1 }) => {
  const requestParams = {
    homepage: true,
    'page[limit]': count,
    'page[offset]': offset,
    near: [lat, lon].join(','),
    mini: 'true',
    ...params,
  };

  const rentalsData = await apiRequest({
    url: `${getSearchApi()}/rentals`,
    params: requestParams,
  });

  return rentalsData?.data;
};

export default rentalsRequest;
